$(document).ready(function() {

    /*
    ========================================
    DEPOSIT / CART BUTTON
    ========================================
    */

    $("#btnDeposit").on("click", function(e) {

        e.preventDefault();

        var url_deposit =
            "https://store.langmuirsystems.com/cart/42193318740046:1,";


        /*
        ----------------------------------------
        ADD-ONS
        ----------------------------------------
        */

        if ($('#addOn1').is(':checked')) {
            url_deposit += '41257831563342:1,';
        }

        if ($('#addOn2').is(':checked')) {
            url_deposit += '41257864134734:1,';
        }

        if ($('#addOn3').is(':checked')) {
            url_deposit += '41257877962830:1,';
        }

        if ($('#addOn4').is(':checked')) {
            url_deposit += '41343418400846:1,';
        }

        if ($('#addOn5').is(':checked')) {
            url_deposit += '41399119872078:1,';
        }

        if ($('#addOn6').is(':checked')) {
            url_deposit += '41548920553550:1,';
        }

        if ($('#silver-plan').is(':checked')) {
            url_deposit += '42622239572046:1,';
        }


        /*
        ----------------------------------------
        TOOLING PACKAGES
        ----------------------------------------
        */

        $('.ajax-add-to-cart-btn.is-added').each(function() {

            var variant_id = $(this).data('variant-id');

            if (variant_id) {
                url_deposit += variant_id + ':1,';
            }

        });


        /*
        ----------------------------------------
        QUANTITY PRODUCTS
        ----------------------------------------
        */

        $('.qtybox .quantity-input').each(function() {

            var qty = $(this).val();
            var shopify_id = $(this).data('id');

            if (qty > 0) {
                url_deposit += shopify_id + ':' + qty + ',';
            }

        });


        /*
        ----------------------------------------
        GO TO CART
        ----------------------------------------
        */

        window.location.href = url_deposit;
    });



    /*
    ========================================
    QUANTITY BUTTONS
    ========================================
    */

    $('.qtybox .btnqty').on('click', function() {

        var label = $('#package-price');

        var total = parseFloat(
            label.text().replace(/,/g, '')
        ) || 0;

        var qty = parseInt(
            $(this)
                .parent('.qtybox')
                .find('.quantity-input')
                .val()
        );

        var price = parseFloat(
            $(this)
                .parent('.qtybox')
                .find('.quantity-input')
                .data('price')
        ) || 0;


        if ($(this).hasClass('qtyplus')) {

            qty++;
            total += price;

        } else {

            if (qty > 0) {
                qty--;
                total -= price;
            }

        }


        qty = isNaN(qty) ? 1 : qty;


        $(this)
            .parent('.qtybox')
            .find('.quantity-input')
            .val(qty);


        label.text(
            formatPrice(total)
        );


        /*
        Update Affirm
        */

        $('.affirm-as-low-as').attr(
            'data-amount',
            total * 100
        );


        refreshAffirm();

        return false;
    });



    /*
    ========================================
    ADD-ONS
    ========================================
    */

    $(
        '#addOn1, #addOn3, #addOn4, #addOn5, #addOn6, .titan-plan'
    ).on('change', function() {

        var label = $('#package-price');

        var total = parseFloat(
            label.text().replace(/,/g, '')
        ) || 0;

        var price = parseFloat(
            $(this).data('price')
        ) || 0;


        if ($(this).is(':checked')) {

            total += price;

        } else {

            total -= price;

        }


        label.text(
            formatPrice(total)
        );


        /*
        Update Affirm
        */

        $('.affirm-as-low-as').attr(
            'data-amount',
            total * 100
        );


        refreshAffirm();

    });



    /*
    ========================================
    ADD-ON 2
    ========================================
    */

    $('#addOn2').on('change', function() {

        var label = $('#package-price');

        var total = parseFloat(
            label.text().replace(/,/g, '')
        ) || 0;

        var price = parseFloat(
            $(this).data('price')
        ) || 0;


        if ($(this).is(':checked')) {

            total += price;


            /*
            Remove Add-On 5 price
            */

            if ($('#addOn5').is(':checked')) {

                var feet_price = parseFloat(
                    $('#addOn5').data('price')
                ) || 0;

                total -= feet_price;
            }


            $('#addOn5').prop(
                'checked',
                false
            );

            $('#addOn5').prop(
                'disabled',
                true
            );

        } else {

            total -= price;


            $('#addOn5').prop(
                'checked',
                false
            );

            $('#addOn5').prop(
                'disabled',
                false
            );

        }


        label.text(
            formatPrice(total)
        );


        /*
        Update Affirm
        */

        $('.affirm-as-low-as').attr(
            'data-amount',
            total * 100
        );


        refreshAffirm();

    });



    /*
    ========================================
    TOOLING PACKAGES
    ========================================
    */

    $('.ajax-add-to-cart-btn').on('click', function(e) {

        e.preventDefault();

        var button = $(this);

        var label = $('#package-price');

        var total = parseFloat(
            label.text().replace(/,/g, '')
        ) || 0;

        var price = parseFloat(
            button.data('price')
        ) || 0;


        /*
        ----------------------------------------
        REMOVE TOOLING PACKAGE
        ----------------------------------------
        */

        if (button.hasClass('is-added')) {

            total -= price;

            button.removeClass('is-added');

            button
                .find('.btn-text')
                .text('Add To Cart');

        }


        /*
        ----------------------------------------
        ADD TOOLING PACKAGE
        ----------------------------------------
        */

        else {

            total += price;

            button.addClass('is-added');

            button
                .find('.btn-text')
                .text('Added +1');

        }


        /*
        ----------------------------------------
        UPDATE PACKAGE PRICE
        ----------------------------------------
        */

        label.text(
            formatPrice(total)
        );


        /*
        ----------------------------------------
        UPDATE AFFIRM
        ----------------------------------------
        */

        $('.affirm-as-low-as').attr(
            'data-amount',
            total * 100
        );


        refreshAffirm();

        return false;
    });



    /*
    ========================================
    FORMAT PRICE
    ========================================
    */

    function cents(value) {

        return (
            Math.round(100 * value) / 100
        ).toFixed(2);

    }


    function formatPrice(value) {

        value = parseFloat(value) || 0;

        return value.toLocaleString(
            'en-US',
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        );

    }


    /*
    ========================================
    AFFIRM REFRESH
    ========================================
    */

    function refreshAffirm() {

        if (
            typeof affirm !== 'undefined' &&
            affirm.ui &&
            typeof affirm.ui.refresh === 'function'
        ) {

            affirm.ui.refresh();

        }

    }

});

